module.exports = __webpack_public_path__ + "media/images/home-banner-d467e9eac03caf6bb0fe6cf984aef750.jpg";